import './Logo.css';

/**
 * Alphafocus brand logo.
 *
 * The mark is a raster image, so it cannot follow the Light/Dark token modes on
 * its own — the correct file is selected in CSS, mirroring exactly how
 * tokens.generated.css declares dark (see Logo.css for why all four selectors
 * are required). Never pass the theme in as a prop: Login renders outside
 * AppShell and has no data-theme on the root, so a prop would be wrong there.
 *
 * @param {'lockup'|'mark'} variant  lockup = mark + wordmark, mark = mark alone
 * @param {'sm'|'md'|'lg'|'xl'} size mark box: 20 / 24 / 32 / 64 px, with the
 *   wordmark at a fixed 0.625x of it (12 / 15 / 20 / 40) — `lg` is Figma's
 *   Lockup L verbatim. See the size-ladder note in Logo.css before changing one.
 */
export default function Logo({ variant = 'lockup', size = 'md', className = '', ...rest }) {
    const isLockup = variant === 'lockup';

    return (
        <span
            className={`logo logo--${size} logo--${isLockup ? 'lockup' : 'mark'} ${className}`.trim()}
            {...rest}
        >
            <span
                className="logo__mark"
                /* In a lockup the wordmark already names the brand, so the mark
                   is decorative. Alone, it must carry the accessible name. */
                role={isLockup ? undefined : 'img'}
                aria-label={isLockup ? undefined : 'Alphafocus'}
                aria-hidden={isLockup ? 'true' : undefined}
            />
            {isLockup && (
                <span className="logo__word">
                    Alpha<span className="logo__word-accent">focus</span>
                </span>
            )}
        </span>
    );
}
